import React from 'react';

import PrivateChat from '../../components/PrivateChat/PrivateChat';

import './MemberChat.css';


class MemberChat extends React.Component {
  render() {
    return (
      <div id="member-chat">

        <div className="container member-chat-container">
          <PrivateChat />
        </div>
      </div>
    );
  }
}

export default MemberChat;
